import { AppIcon, RawSVG } from 'core/components/icons/icon.type';

export const iconRadiobutton: AppIcon = {
  svgData: '<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" style="transform: scale(0.87)"><rect width="20" height="20" rx="10" fill="currentColor"/></svg>' as RawSVG,
  name: 'radiobutton',
};
